// Card no dashboard financeiro mostrando próximas cobranças recorrentes
// a serem geradas (todas ativas, ordenadas por next_run_at).

import React, { useCallback, useEffect, useState } from 'react';
import { Card, Typography, Space, Tag, Button, Empty } from 'antd';
import { CalendarOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../../../services/api';
import dayjs from 'dayjs';

const { Text } = Typography;
const PRIMARY = '#128C7E';
const fmtBRL = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

export default function UpcomingRecurrencesCard({ communityTeamId }) {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!communityTeamId) return;
    setLoading(true);
    try {
      const r = await api.get('/community/finance/charges/recurrences', { params: { team_id: communityTeamId } });
      const all = r.data.items || [];
      const active = all.filter(x => x.status === 'active');
      active.sort((a, b) => {
        const ta = a.next_run_at ? new Date(a.next_run_at).getTime() : Infinity;
        const tb = b.next_run_at ? new Date(b.next_run_at).getTime() : Infinity;
        return ta - tb;
      });
      setItems(active.slice(0, 5));
    } catch { /* silent */ }
    finally { setLoading(false); }
  }, [communityTeamId]);
  useEffect(() => { load(); }, [load]);

  if (!loading && items.length === 0) {
    return (
      <Card
        title={<Space><CalendarOutlined /><Text strong>Próximas cobranças recorrentes</Text></Space>}
        styles={{ header: { padding: '12px 16px' }, body: { padding: 16 } }}
        extra={<Button type="link" size="small" onClick={() => nav('/comunidade/financeiro/recorrencias')}>Configurar <ArrowRightOutlined /></Button>}
        style={{ marginBottom: 16 }}
      >
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div>
              <Text strong>Sem recorrência ativa</Text>
              <br />
              <Text type="secondary" style={{ fontSize: 12 }}>Deixa a mensalidade no automático — todo dia X do mês, sem esforço.</Text>
            </div>
          }
        >
          <Button type="primary" style={{ background: PRIMARY, borderColor: PRIMARY }}
            onClick={() => nav('/comunidade/financeiro/recorrencias')}>
            Criar recorrência
          </Button>
        </Empty>
      </Card>
    );
  }

  return (
    <Card
      title={<Space><CalendarOutlined /><Text strong>Próximas cobranças recorrentes</Text></Space>}
      styles={{ header: { padding: '12px 16px' }, body: { padding: 12 } }}
      extra={<Button type="link" size="small" onClick={() => nav('/comunidade/financeiro/recorrencias')}>Ver todas <ArrowRightOutlined /></Button>}
      style={{ marginBottom: 16 }}
    >
      {loading ? (
        <Text type="secondary">Carregando…</Text>
      ) : (
        <Space direction="vertical" style={{ width: '100%' }} size={8}>
          {items.map(r => (
            <div key={r.id} style={{
              padding: 12, borderRadius: 8, border: '1px solid #f0f0f0',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap',
            }}>
              <div style={{ flex: '1 1 240px', minWidth: 0 }}>
                <Text strong style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {r.template_name}
                </Text>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {r.next_run_at ? `Roda em ${dayjs(r.next_run_at).format('DD/MM')}` : 'Sem próxima definida'}
                  {r.source_type === 'group' && r.group_name && <> · Grupo: {r.group_name} ({r.group_size || 0})</>}
                </Text>
              </div>
              <Tag color="green" style={{ margin: 0 }}>{fmtBRL(r.amount_brl)}/pessoa</Tag>
            </div>
          ))}
        </Space>
      )}
    </Card>
  );
}
